import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["blockquote", "code-block"],
    ["link", "image"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "align",
  "blockquote",
  "code-block",
  "link",
  "image",
];

const RichTextEditor = ({ value, onChange, placeholder = "Enter description..." }) => {
  return (
    <div className="w-full">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
        className="bg-white mb-2 rounded-md text-[16px]"
      />

      {/* Global style fix for font size + medium weight */}
      <style jsx global>{`
        .ql-editor::before {
          font-size: 16px !important;
          color: #9ca3af !important; /* Tailwind's text-gray-400 */
          font-weight: 500 !important; /* medium font weight */
          opacity: 1 !important;
        }

        .ql-editor {
          min-height: 120px;
          font-size: 16px !important;
          font-weight: 500 !important; /* medium text inside editor too */
          line-height: 1.5;
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
